import {GET_LAST_INVOICES_SUCCESS, GET_OVERVIEW_SUCCESS} from "../constants/Dashboards";

const initialState = {
  overview: {
    weekly_revenue: {
      date_range: "",
      this_week: "",
      delta: "",
      categories: [],
      series: [
        {
          name: "",
          data: []
        }
      ]
    },
    stats: {
      conversion_rate: 0,
      last_30: 0,
      last_365: 0,
      total_customers: 0
    },
    top_manufacturers: {
      year_totals: {},
      month_totals: {},
      week_totals: {}
    },
    sales: {
      year_totals: {},
      month_totals: {},
      week_totals: {}
    },
    customers: {
      last_year: {},
      this_year: {},
      last_month: {},
      this_month: {},
      last_week: {},
      this_week: {},
      total_customers: 0
    },
    lastInvoices: [],
    overviewLoaded: false,
    invoicesLoaded: false,
  }
}

const dashboards = (state = initialState, action) => {
  switch (action.type) {
    case GET_OVERVIEW_SUCCESS:
      return {
        ...state,
        overview: {
          ...state.overview,
          ...action.data,
          overviewLoaded: true,
        },
      }
    case GET_LAST_INVOICES_SUCCESS:
      return {
        ...state,
        overview: {
          ...state.overview,
          lastInvoices: action.invoices,
          invoicesLoaded: true,
        },
      };
    default:
      return state;
  }
}

export default dashboards